module.exports = function() {
  return new Worker(__webpack_public_path__ + "692019c97c562750a28c.worker.js");
};